import $ from 'jquery';
import selectize from 'selectize';// eslint-disable-line no-unused-vars
import enquire from 'enquire.js';// eslint-disable-line no-unused-vars
import slick from 'slick-carousel';// eslint-disable-line no-unused-vars
import main from '../scss/init.scss';// eslint-disable-line no-unused-vars
import './head-shrink';
import './load-more';
import './cookies-panel';
import './head-search';
import './main-search';
import './custom-select';
import './carousels';
import './accordion';
import './menu-dropdown';
import './mobile-navigation';
import './to-top';
import './sticky';
import './account';
import './progress-bar';
import './discount-code';
import './footer-bottom-stick';
import './validate';
import './dropdown-disable';

window.jQuery = $;
window.$ = $;

require('./jquery.headshrinker.js');
require('./sticky-kit.min.js');



/** WEBPACK FOOTER **
 ** ./src/js/main.js
 **/